import getEnvFromUrl, { getEnvNamesForValue, getEnvTypeFromUrl } from './getEnvFromUrl';
import replaceConfigEnvTemplate from './replaceConfigEnvTemplate';

const STORAGE_ENV_KEY_NAME = 'env';

const getFallbackConfigEnvName = () => {
  return getEnvTypeFromUrl() || getEnvFromUrl();
};

let defaultEnv = getFallbackConfigEnvName();

let overrideEnv;

try {
  overrideEnv = localStorage.getItem(STORAGE_ENV_KEY_NAME);
} catch (e) {
  console.warn('env-config', 'Cannot read environment override from local storage');
}

const config = ENV || {};

let isGetEnvNameCalled = false;

export const setDefaultEnv = (envName) => {
  if (isGetEnvNameCalled) {
    console.error(
      'env-config',
      'You set the default environment after the environment was already called, your application may be in an inconsistent state!'
    );
  }

  defaultEnv = envName;
};

const getConfEnvNameForOverride = (override) => {
  const names = getEnvNamesForValue(override);
  return names.envType || names.fullEnvName || override;
};

export const getConfEnvName = () => {
  isGetEnvNameCalled = true;
  return overrideEnv ? getConfEnvNameForOverride(overrideEnv) : defaultEnv;
};

const get = (object, path, defaultVal) => {
  const _path = Array.isArray(path) ? path : path.split('.').filter((i) => i.length);

  if (!_path.length) {
    return object;
  } else if (object === undefined) {
    return defaultVal;
  }

  return get(object[_path.shift()], _path, defaultVal);
};

const getEnvConfig = (path = null) => {
  const confEnvName = getConfEnvName();

  //replace URL templates with current env
  const envNameValue = overrideEnv || getEnvFromUrl();
  const envConfig = replaceConfigEnvTemplate(envNameValue, (config[confEnvName] || {}));

  return path ? get(envConfig, path) : envConfig;
};

export default getEnvConfig;
